import { i as t } from "../../../chunk-GSYRQO2U-911f8fc9.js";
import { a as o } from "../../../chunk-OA3DH5LS-40f95340.js";
const i = o("Avatar").parts(
  ...t.keys,
  "control",
  "fieldWithLeftAddon",
  "fieldWithRightAddon",
  "leftAddon",
  "rightAddon",
  "smartAnimation"
);
export {
  i as InputAnatomy
};
//# sourceMappingURL=Input.anatomy.es.js.map
